import { frappeMethod } from "./utils";

export type ExportListParams = {
  doctype: string;
  fields: string[];
  filters?: unknown[];
  orderBy?: string;
  fileFormat?: "csv" | "xlsx";
  dateFrom?: string;
  dateTo?: string;
  dateField?: string;
  docNames?: string[];
};

export type ExportListResult = {
  filename: string;
  content: string;
  exported_count: number;
  total_count?: number;
  truncated?: boolean;
  empty?: boolean;
  format?: "base64";
  date_field?: string;
};

export const listExport = {
  exportList(params: ExportListParams): Promise<ExportListResult> {
    return frappeMethod<ExportListResult>(
      "zaviago_backend.storefront.list_export.export_list",
      {
        doctype: params.doctype,
        fields: JSON.stringify(params.fields),
        filters: JSON.stringify(params.filters ?? []),
        order_by: params.orderBy,
        file_format: params.fileFormat ?? "csv",
        date_from: params.dateFrom,
        date_to: params.dateTo,
        date_field: params.dateField,
        doc_names: params.docNames
          ? JSON.stringify(params.docNames)
          : undefined,
      },
    );
  },
};
